// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgUserStar = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 10a3.333 3.333 0 1 0 0-6.667A3.333 3.333 0 0 0 10 10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.167 16.667v-.834a5.833 5.833 0 0 1 8.333-5.272M13.863 13.68l.865-1.837a.297.297 0 0 1 .544 0l.865 1.836 1.937.297c.248.037.347.357.167.54l-1.4 1.428.33 2.018c.043.259-.217.457-.44.334L15 17.343l-1.732.953c-.222.123-.482-.075-.44-.334l.331-2.017-1.4-1.428c-.18-.184-.081-.503.167-.541z"
    />
  </svg>
);
export const UserStarIcon = forwardRef(SvgUserStar);
